var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgExpiredIllustration = function SvgExpiredIllustration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 114,
    viewBox: "0 0 109 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 48,
    fill: "#F6D2B7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2687 66C97.0375 60.9955 98 55.6102 98 50C98 23.4903 76.5097 2 50 2C23.4903 2 2 23.4903 2 50C2 76.5097 23.4903 98 50 98C54.324 98 58.5145 97.4282 62.5 96.3562",
    stroke: "#697684",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23V56H27",
    stroke: "#697684",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0109 69C74.9591 69 66.0053 77.9343 66 88.9553C66 99.9764 74.9591 108.905 86.0109 108.911C97.0626 108.911 106.016 99.9764 106.016 88.9553C106.016 77.9343 97.0626 69 86.0109 69Z",
    fill: "#D76106"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.677 81.75C105.544 83.9836 106.018 86.4111 106.018 88.9541C106.018 99.9751 97.0636 108.904 86.0119 108.909C79.4713 108.909 73.6615 105.779 70.0127 100.935C72.9097 108.396 80.1759 113.686 88.6776 113.686C99.7293 113.686 108.683 104.752 108.683 93.7358C108.683 89.2372 107.19 85.0846 104.677 81.75Z",
    fill: "#F6D2B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 79C87.1046 79 88 79.8357 88 80.8667V88.3333C88 89.3643 87.1046 90.2 86 90.2C84.8954 90.2 84 89.3643 84 88.3333V80.8667C84 79.8357 84.8954 79 86 79Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 96.2C84 95.0954 84.891 94.2 85.99 94.2H86.01C87.109 94.2 88 95.0954 88 96.2C88 97.3046 87.109 98.2 86.01 98.2H85.99C84.891 98.2 84 97.3046 84 96.2Z",
    fill: "white"
  })));
};
var Memo = /*#__PURE__*/memo(SvgExpiredIllustration);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/illustrations/ExpiredIllustration.e07e606ab0e88e85e8aaa0d229121af6.svg";